import { Injectable } from '@angular/core';
import { ParcelType } from '@app/business/business-models';
import { TranslateService } from '@ngx-translate/core';
import { IParcelTypeOptions, ParcelStatus } from '../business-requested-history.models';

@Injectable({
  providedIn: 'root'
})
export class BusinessRequestedHistoryInitService {

  constructor(
    private translateService: TranslateService
  ) { }

  setDisplayedColumns() {
    return [
      'status',
      'signCountTxt',
      'date',
      'downloadeTimestamp',
      'type',
      'packageName',
      'documentsCount',
      'actions'
    ];
  }

  setParcelTypeOptions() {
    const ParcelTypeOptions: IParcelTypeOptions[] = [
      { type: 'ALL', textToVisualize: this.translateService.stream('historyTexts.all') },
      { type: ParcelType.BATCH_SIGNING, textToVisualize: this.translateService.stream('historyTexts.packageDocuments') },
      { type: ParcelType.REGISTERED_DELIVERY, textToVisualize: this.translateService.stream('historyTexts.registeredMail') }
    ]

    return ParcelTypeOptions;
  }

  setParcelStatusLabels() {
    return [
      { status: ParcelStatus.ALL, textToVisualize: this.translateService.stream('historyTexts.all') },
      { status: ParcelStatus.IN_PROGRESS, textToVisualize: this.translateService.stream('historyTexts.documentStatusSigning') },
      { status: ParcelStatus.SIGNED, textToVisualize: this.translateService.stream('historyTexts.documentStatusSigned') },
      { status: ParcelStatus.RECEIVED, textToVisualize: this.translateService.stream('historyTexts.documentStatusReceived') },
      { status: ParcelStatus.REJECTED, textToVisualize: this.translateService.stream('historyTexts.documentStatusRejected') },
      { status: ParcelStatus.ARCHIVED, textToVisualize: this.translateService.stream('historyTexts.documentStatusArchived') },
      { status: ParcelStatus.DELETED, textToVisualize: this.translateService.stream('historyTexts.documentStatusDeleted') },
      { status: ParcelStatus.EXPIRED, textToVisualize: this.translateService.stream('historyTexts.documentStatusExpired') },
      { status: ParcelStatus.PENDING, textToVisualize: this.translateService.stream('historyTexts.documentStatusRegisteredMailPending') },
      { status: ParcelStatus.SENT, textToVisualize: this.translateService.stream('historyTexts.documentStatusSentPackage') },
      { status: ParcelStatus.DELIVERED, textToVisualize: this.translateService.stream('historyTexts.documentStatusDelivered') },
      { status: ParcelStatus.VIEWED, textToVisualize: this.translateService.stream('historyTexts.documentStatusViewed') },
      { status: ParcelStatus.FAILED, textToVisualize: this.translateService.stream('historyTexts.documentStatusError') },
    ]
  }
}
